import React from 'react';
import PropTypes from 'prop-types';
import LayoutSelection from '../components/LayoutSelection.jsx';
import ProjectViewTypeList from './ProjectViewTypeList.jsx';
import FilterByFlag from '../components/Filter/FilterByFlag.jsx';
import FilterByDistance from '../components/Filter/FilterByDistance.jsx';
import FilterByTaskName from '../components/Filter/FilterByTaskName.jsx';
import FilterByStatus from '../components/Filter/FilterByStatus.jsx';
import FilterByCode from '../components/Filter/FilterByCode.jsx';
import FilterByDate from '../components/Filter/FilterByDate.jsx';
import FilterByFloat from '../components/Filter/FilterByFloat.jsx';
import FilterByResources from '../components/Filter/FilterByResources.jsx';
import FilterByPhotos from '../components/Filter/FilterByPhotos.jsx';
import FilterByChanges from '../components/Filter/FilterByChanges.jsx';
import FlyoutRightButtons from '../components/FlyoutRightButtons.jsx';
import classnames from 'classnames';
import { Panel } from 'react-bootstrap';

const FlyoutRight = ({
	isActive,
	setIsFlyoutRightActive,
	closeButtonRef,
	onRequestClose,
	setIsCapturingScreenshot,
	datasetInfo,
	projectFilter,
	setProximityDistance,
	setMapPinMyLocation,
	mapPinMyLocation,
	mapPinPickMode,
	setMapPinPickMode,
	projectViewType
}) => {
	if (!datasetInfo) {
		return null;
	}

	const classes = classnames('flyoutRight flyout', {active: isActive});

	return (<div
		id="views-flyout"
		className={classes}
		role="dialog"
		aria-modal={isActive ? 'true' : undefined}
		aria-label="Views"
		aria-hidden={!isActive}
		inert={!isActive ? '' : undefined}>
		<FlyoutRightButtons
			setIsFlyoutRightActive={setIsFlyoutRightActive}
			closeButtonRef={closeButtonRef}
			onRequestClose={onRequestClose} />

		<div className="flyoutContent">
			<LayoutSelection setIsCapturingScreenshot={setIsCapturingScreenshot} datasetInfo={datasetInfo} />

			<ProjectViewTypeList datasetInfo={datasetInfo} />

			<Panel className="flyoutFiltersPanel" defaultExpanded>
				<Panel.Heading>
					<Panel.Title toggle>Filters</Panel.Title>
				</Panel.Heading>
				<Panel.Collapse>
					<div className="flyoutFiltersBody">
						<FilterByTaskName />
						<FilterByStatus />
						<FilterByCode />
						<FilterByDate />
						<FilterByFloat />
						<FilterByResources />
						<FilterByFlag />
						<FilterByPhotos />
						{projectViewType === 'Map' && <FilterByDistance
							projectFilter={projectFilter}
							setProximityDistance={setProximityDistance}
							setMapPinMyLocation={setMapPinMyLocation}
							mapPinMyLocation={mapPinMyLocation}
							mapPinPickMode={mapPinPickMode}
							setMapPinPickMode={setMapPinPickMode}
							setIsFlyoutRightActive={setIsFlyoutRightActive} />}
						<FilterByChanges />
					</div>
				</Panel.Collapse>
			</Panel>
		</div>
	</div>);
};

export default FlyoutRight;

FlyoutRight.propTypes = {
	isActive: PropTypes.bool,
	setIsFlyoutRightActive: PropTypes.func,
	closeButtonRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.any })
	]),
	onRequestClose: PropTypes.func,
	setIsCapturingScreenshot: PropTypes.func,
	datasetInfo: PropTypes.object,
	projectFilter: PropTypes.shape({
		searchText: PropTypes.string
	}),
	projectViewType: PropTypes.string,
	setProximityDistance: PropTypes.func,
	setMapPinMyLocation: PropTypes.func,
	mapPinMyLocation: PropTypes.shape({
		lat: PropTypes.number,
		lng: PropTypes.number
	}),
	mapPinPickMode: PropTypes.bool,
	setMapPinPickMode: PropTypes.func
};